// extracted by mini-css-extract-plugin
export default {"pageWrap":"Qb-z","fullWidth":"Rb-z","heading":"Sb-z","fullBleed":"Tb-z","hidden":"Ub-z"};